import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
import UserIcon from '@material-ui/icons/AccountCircle';
import Colors from 'utils/colors';
import Avatar from '@material-ui/core/Avatar';
import Mixpanel from 'utils/mixpanelService';
import { Link } from 'react-router-dom';

const styles = theme => ({
  image: {
    width: 38,
    height: 38,
    borderRadius: '50%',
    background: '#E8F1F5',
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    ...theme.typography.body2,
  },

  root: {
    marginTop: 15,
    marginBottom: 15,
  },
  name: {
    fontSize: 13,
    color: Colors.link,
    fontWeight: 500,
  },
  role: {
    fontSize: 12,
    fontStyle: 'italic',
    fontWeight: 500,
  },
  profession: {
    fontSize: 12,
  },
  viewBio: {
    color: Colors.link,
    fontWeight: 500,
    cursor: 'pointer',
  },
  link: {
    textDecoration: 'none',
  },
  imageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 2.5px',
  },
});

function redirectClickHandler(topicName, editorName) {
  Mixpanel.track('Topic Center Editor - Clicked', {
    topic: topicName,
    name: topicName,
    editorName,
  });
}

function HeaderEditors(props) {
  const { classes, data, topicName, navigateTo } = props;
  /* eslint-disable */
  if (_isEmpty(data)) return null;
  const dataLen = data.length;
  const additionalEditor = dataLen - 3; // display only the three
  return (
    <Grid item className={classes.root}>
      <Grid container direction="row" spacing={1}>
        {data.slice(0, 3).map(item => {
          if (_isEmpty(_get(item, 'fields'))) return null;
          const { fields } = item;
          const hasImage = !_isEmpty(_get(fields, 'image.fields.file.url'));
          const file = hasImage && fields.image.fields.file.url;
          return (
            <Link
              to={`/editors/${fields.slug}`}
              className={classes.link}
              onClick={() => redirectClickHandler(topicName, fields.name)}
              key={fields.slug}
            >
              <Grid item className={classes.imageWrapper}>
                {hasImage ? (
                  <Avatar src={file} className={classes.image} alt="Editor"/>
                ) : (
                  <UserIcon className={classes.image} />
                )}
              </Grid>
            </Link>
          );
        })}
        {additionalEditor >= 1 && (
          <Avatar
            className={classes.image}
            role="button"
            onClick={() => navigateTo('editors')}
            alt="Editor"
          >
            +{additionalEditor}
          </Avatar>
        )}
      </Grid>
    </Grid>
  );
}

HeaderEditors.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.array,
  topicName: PropTypes.string,
  navigateTo: PropTypes.func,
};

export default withStyles(styles)(HeaderEditors);
